// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:b45a2550-325f-445d-9c70-bc63ce98e034",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_iDGcxsABo",
    "aws_user_pools_web_client_id": "53ha9qtkggpghnckaag79pre3r",
    "oauth": {}
};


export default awsmobile;
